import { render, staticRenderFns } from "./InvE.vue?vue&type=template&id=3b2141d0"
import script from "./InvE.vue?vue&type=script&lang=js"
export * from "./InvE.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports